import { Interface, type } from 'implement-js'

export const LayoutInterface = Interface('Layout')(
  {
    Header: type('function'),
    Drawer: type('function'),
  },
  { error: true },
)
